import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import {
  DomainObject,
  TableFieldCells,
  TableFieldColumn,
} from '@eas/common-web';
import { Absence } from '@models';

const formatDate = (dateString?: string): ReactNode =>
  dateString ? (
    <>
      {new Date(dateString).toLocaleDateString('sk-SK', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })}
      {' | '}
      {new Date(dateString).toLocaleTimeString('sk-SK', {
        hour: '2-digit',
        minute: '2-digit',
      })}
    </>
  ) : (
    ''
  );

export function useColumns<T extends DomainObject>(): TableFieldColumn<T>[] {
  const intl = useIntl();

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__ABSENCES__TABLE__COLUMN__NAME',
        defaultMessage: 'Názov',
      }),
      datakey: 'absenceType.name',
      sortkey: 'absenceType.name',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ABSENCES__TABLE__COLUMN__FROM_TO',
        defaultMessage: 'Platnosť',
      }),
      datakey: 'id',
      width: 350,
      sortkey: 'fromDate',
      CellComponent: (props) => {
        const { fromDate, toDate } = props.rowValue as Absence;
        return (
          <TableFieldCells.TextCell
            {...props}
            value={
              <>
                {formatDate(fromDate)} - {formatDate(toDate)}
              </>
            }
          />
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ABSENCES__TABLE__COLUMN__ALLOWED',
        defaultMessage: 'Schválená',
      }),
      datakey: 'allowed',
      sortkey: 'allowed',
      width: 120,
      CellComponent: TableFieldCells.BooleanCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ABSENCES__TABLE__COLUMN__CREATED_JOINED',
        defaultMessage: 'Vytvoril',
      }),
      datakey: '_created-joined',
      width: 320,
      CellComponent: (props) => {
        const { created, createdBy } = props.rowValue as Absence;
        return (
          <TableFieldCells.TextCell
            {...props}
            value={
              <>
                {createdBy?.name ?? ''} - {formatDate(created)}
              </>
            }
          />
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__ABSENCES__TABLE__COLUMN__UPDATED_JOINED',
        defaultMessage: 'Aktualizoval',
      }),
      datakey: '_updated-joined',
      width: 320,
      CellComponent: (props) => {
        const { updated, updatedBy } = props.rowValue as Absence;
        return (
          <TableFieldCells.TextCell
            {...props}
            value={
              <>
                {updatedBy?.name ?? ''} - {formatDate(updated)}
              </>
            }
          />
        );
      },
    },
  ];
}
